/**
 * 本应用对应权限字段
 */
export const AppUrl = {
  'xag-ai-cloud.edge-deloy': 'xag-ai-application.edge-deloy',
  // 报表中心
  'xag-ai-report.label-history': 'xag-ai-common.label-history',
  'xag-ai-report.label-mark': 'xag-ai-common.label-mark',
  'xag-ai-report.label-require': 'xag-ai-common.label-require',

  'xag-ai-report.label-require-aduit': 'xag-ai-common.label-require-aduit',
  'xag-ai-report.label-require-aduit-notpass':
    'xag-ai-common.label-require-aduit-notpass',
  'xag-ai-report.require-data': 'xag-ai-common.require-data',

  'xag-ai-report.label-require-clean-task':
    'xag-ai-common.label-require-clean-task',
  'xag-ai-report.label-require-clean': 'xag-ai-common.label-require-clean',
  'xag-ai-report.label-require-accept-notpass':
    'xag-ai-common.label-require-accept-notpass',

  home: 'home',
  'xag-ai-business.document': 'xag-ai-common.document',
  'xag-ai-business.convert': 'xag-ai-dimension.convert',
  'xag-ai-business.convert-polygon': 'xag-ai-common.convert',
  'xag-ai-business.datapollauth': 'xag-ai-dataset.authorization',

  // 在线应用
  'xag-ai-online-app.myinference': 'xag-ai-inference.myinference',
  'xag-ai-online-app.application': 'xag-ai-application.application',
  'xag-ai-online-app.algorithm': 'xag-ai-algorithm.algorithm',
  'xag-ai-online-app.model': 'xag-ai-algorithm.model',

  // 边缘应用

  'xag-ai-edge-app.edgeapplication': 'xag-ai-application.edgeapplication',
  'xag-ai-edge-app.edge-algorithm': 'xag-ai-algorithm.edge-algorithm',
  'xag-ai-edge-app.edge-model': 'xag-ai-algorithm.edge-model',

  // 配有菜单的转换
  'xag-ai-dimension.team-labeling-requirement-root.team-labeling-requirement':
    'xag-ai-dimension.team-labeling-requirement',
  'xag-ai-dimension.annotation-task-root.annotation-task':
    'xag-ai-dimension.annotation-task',
};

export const corverProject = Object.keys(AppUrl).reduce((acc, key) => {
  acc[AppUrl[key]] = key;
  return acc;
}, {});
